module.exports = __webpack_public_path__ + "fonts/Noto_Serif_JP-400-558.4c8b52c.woff2";